// extracted by mini-css-extract-plugin
module.exports = {"tcoButton":"_1cM9t3"};